import React from 'react';

import { black, green01, progressBarBackground } from '../../theme';

interface ProgressBarProps {
  title: string;
  overallProgress: number;
}

export const ProgressBar: React.FC<ProgressBarProps> = ({ title, overallProgress }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div
        className="p-6 rounded-lg max-w-lg w-full mx-4 backdrop-blur-sm"
        style={{ backgroundColor: progressBarBackground }}
      >
        <h3 className="text-lg font-semibold mb-4 text-center" style={{ color: black }}>
          {title}
        </h3>
        <div className="mb-4">
          <div className="w-full bg-gray-300 rounded-full h-3">
            <div
              className="h-3 rounded-full transition-all duration-300"
              style={{
                width: `${Math.min(overallProgress, 100)}%`,
                backgroundColor: green01,
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
